// extracted by mini-css-extract-plugin
module.exports = {"BackdropPopupContainer":"Modal_BackdropPopupContainer__1Z3fs","BackdropPopup":"Modal_BackdropPopup__294w5","Close":"Modal_Close__NE2CG","Tilte":"Modal_Tilte__3AGaU"};